@if ((url$ | async); as url)
{
    <div>
        <img [src]="url" (load)="imageLoaded()" />
    </div>
} @else
{
}

